/* Holds the disclaimer data from the spreadsheet */

const DCData = class {
	constructor() {}
	
	getSection(mysection) {
		return this[mysection] ? this[mysection] : null ; 		
	}
	
};

export default DCData; 
